import Model, { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type TasApplicationModel from './tas-application';

export default class AiRecommendationModel extends Model {
  // Basic attributes
  @attr declare action: string;
  @attr declare actionable: boolean;
  @attr declare breakdownOfPayment: Record<string, unknown>;
  @attr declare contextForRecommendation: Record<string, unknown>;
  @attr declare contextHexdigest: string;
  @attr declare recommendableType: string;
  @attr declare recommendableId: string;
  @attr declare recommendedTo: string;
  @attr declare responseJson: Record<string, unknown>;
  @attr declare createdAt: string;
  @attr declare updatedAt: string;

  // Relationships
  @belongsTo('tas-application', { async: false, inverse: 'aiRecommendations', polymorphic: false })
  declare recommendable: TasApplicationModel;

  // Computed properties
  get isCompleted() {
    return this.actionable;
  }

  get hasData() {
    return Boolean(this.responseJson && Object.keys(this.responseJson).length > 0);
  }

  [Type] = 'ai-recommendation' as const;
}
